import { Route } from "@dashboard/components/Router";
import React from "react";

import AppDetailView from "./views/AppDetailView";

export const EnvSettingsSection = () => (
  <Route exact path="/third-party-integrations/:appType" component={AppDetailView} />
);

export default EnvSettingsSection;